import { Component, OnInit } from '@angular/core';
import {UserService} from '../services/user.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  selector: 'footer'
 })
 
export class FooterComponent implements OnInit { 
private hex = require("../../assets/hex.jpg");
  
  constructor( private userSVC: UserService, private router: Router ){}

  ngOnInit(){
  }

  tagndoc(){
    this.router.navigate(['https://tst.tagndoc.com']);
  }
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts